import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';

export default function SocialWidget() {
  return (
    <div className="cs_social_links_wrap">
      {/* <h2>Follow Us</h2> */}
      <div className="cs_social_links">
        <Link to="https://www.facebook.com/getafixmd" target='_blank' style={{ backgroundColor: '#0effbe', width: '36px', height: '36px' }}>
          <Icon icon="fa-brands:facebook-f" style={{ color: '#0e6ebe', fontSize: '18px' }} />
        </Link>
        <Link to="https://www.linkedin.com/company/getafixmd" target='_blank' style={{ backgroundColor: '#0effbe', width: '36px', height: '36px' }}>
          <Icon icon="fa-brands:linkedin-in" style={{ color: '#0e6ebe', fontSize: '18px' }} />
        </Link>
        <Link to="https://www.instagram.com/getafixmd_healthcare" target='_blank' style={{ backgroundColor: '#0effbe', width: '36px', height: '36px' }}>
          <Icon icon="fa-brands:instagram" style={{ color: '#0e6ebe', fontSize: '18px' }} />
        </Link>
        <Link to="https://www.youtube.com/@GetAFixMD_official" target='_blank' style={{ backgroundColor: '#0effbe', width: '36px', height: '36px' }}>
          <Icon icon="fa-brands:youtube" style={{ color: '#0e6ebe', fontSize: '18px' }} />
        </Link>
        <Link to="https://x.com/GetAFixMD#" target='_blank' style={{ backgroundColor: '#0effbe', width: '36px', height: '36px' }}>
          <Icon icon="fa-brands:twitter" style={{ color: '#0e6ebe', fontSize: '18px' }} />
        </Link>
      </div>
    </div>
  );
}
